<template>
  <div id="app" :class="{ 'seestadtbot-app': true, 'frontpage': isFrontPage()}">
    <header class="content-container">
      <div class="content-box">
        <div class="header-content">
          <div class="header-logo">
            <router-link to="/" v-if="!isFrontPage()">
              <h1>Seestadt.bot</h1>
            </router-link>
            <div v-else>
              <h1>
                Seestadt.bot
              </h1>
            </div>
          </div>
          <div class="header-navigation">
            <button aria-controls="header-navigation-links" aria-haspopup="true" :aria-expanded="showHeaderNavigation ? 'true' : 'false'" @click="showHeaderNavigation = !showHeaderNavigation">
              <svg viewBox="0 0 100 80" role="img" aria-label="Navigation öffnen">
                <title>Navigation öffnen</title>
                <rect width="100" height="20" rx="8"></rect>
                <rect y="30" width="100" height="20" rx="8"></rect>
                <rect y="60" width="100" height="20" rx="8"></rect>
              </svg>
            </button>
            <nav id="header-navigation-links" :class="{ expanded: showHeaderNavigation }">
              <router-link to="/hilfe">Hilfe</router-link>
              <router-link to="/stadtkatalog/">Seestadt&#8209;Verzeichnis</router-link>
              <router-link to="/stadtkatalog/karte">Karte</router-link>
              <router-link to="/ueber">Impressum</router-link>
              <a href="https://telegram.me/SeestadtBot"><img src="./assets/seestadtbot/telegram.svg" alt=""> Telegram öffnen</a>
              <a href="https://m.me/SeestadtBot"><img src="./assets/seestadtbot/messenger.svg" alt=""> Messenger öffnen</a>
            </nav>
          </div>
        </div>
      </div>
    </header>
    <main class="content-container">
      <div class="content-box">
        <router-view></router-view>
      </div>
    </main>
    <footer class="footer">
      <router-link to="/ueber">Impressum</router-link> | <router-link to="/datenschutz">Datenschutz</router-link>
    </footer>
  </div>
</template>

<script>
import "normalize.css";

export default {
  name: "app",
  data: function() {
    return {
      showHeaderNavigation: false,
    };
  },
  methods: {
    isFrontPage: function() {
      return this.$route.path === "/";
    }
  },
  watch: {
    $route() {
      this.showHeaderNavigation = false;
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/base.scss";
  @import "./assets/ionicons.css";
  @import "~leaflet/dist/leaflet.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  @import "~sass-mq";

  :root {
    --header-height-full: 6rem;
    --header-height-small: 4rem;
    --header-color: #949E4E;
  }

  .seestadtbot {
    padding-bottom: 0;
  }

  #header-navigation-links a {
    cursor: pointer;
  }

  header {
    height: var(--header-height-full);
    background-color: var(--header-color);
    color: #fff;

    @include mq($until: desktop) {
      & {
        height: var(--header-height-small);
      }
    }
  }

  .header-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;

    @include mq($until: desktop) {
      & {
        padding: 0 10px;
      }
    }

    .header-logo {
      width: 100%;

      @include mq($until: desktop) {
        text-align: center;
      }

      a {
        text-decoration: none;
        color: #fff;

        &:hover,
        &:focus {
          text-decoration: underline;
        }
      }

      h1 {
        display: inline-block;

        img {
          width: auto;
          height: 100%;
        }

        font-weight: 500;
        letter-spacing: 0.05em;
        flex: 1 1 auto;
        height: 3.25rem;
        margin: 0;
        padding: 0.3125rem 0 0 0;

        @include mq($until: desktop) {
          & {
            height: 3rem;
            font-size: 1.75rem;
          }
        }
      }
    }

    .header-navigation {
      button {
        @include button-reset;
        background: transparent;
        width: 50px;
        padding-left: 10px;
        padding-right: 10px;

        svg {
          width: 100%;
          rect {
            fill: #fff;
          }
        }
      }

      @include mq($until: desktop) {
        nav {
          display: none;

          &.expanded {
            max-width: 80vw;
            z-index: 1000;
            background-color: var(--header-color);
            display: flex;
            flex-direction: column;
            position: absolute;
            top: calc(var(--header-height-small) - 5px);

            right: 0;
            border-radius: 5px;
            padding: 10px 0 17px 0;
            box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);

            &::before {
              content: "";
              display: block;
              position: absolute;
              left: 0;
              right: 0;
              background-color: var(--header-color);
              z-index: 1100;
              height: 20px;
              top: -10px;
            }
          }

          a {
            font-size: 1.2rem;
            text-align: center;
            color: #fff;
            text-decoration: none;
            padding-left: 30px;
            padding-right: 25px;

            img {
              height: 2.2rem;
              width: auto;
              vertical-align: middle;
              margin-right: 5px;
            }

            + a {
              border-top: 1px solid rgba(255,255,255,0.5);
              margin-top: 17px;
              padding-top: 17px;
            }
          }
        }
      }

      @include mq($from: desktop) {
        & > button {
          display: none;
        }

        nav {
          display: flex;

          a[href^="https://m.me"],
          a[href^="https://telegram.me"],
          a[href^="https://tg.me"] {
            display: none;
          }

          a {
            font-size: 1.4rem;
            text-align: center;
            color: #fff;
            text-decoration: none;

            & + a {
              margin-left: 50px;
            }
          }
        }
      }
    }

    @include mq($from: desktop, $until: wide) {
      .header-logo {
        padding-left: 20px;
      }

      .header-navigation nav {
        padding-right: 25px;
      }
    }
  }

  .seestadtbot .button {
    background: #e6eaeb;
    border-color: #a8b0b3;
  }

  footer {
    .frontpage & {
      @include mq($until: desktop) {
        display: none;
      }
    }

    font-size: 0.75rem;
    line-height: 1.125rem;
    margin-top: 5rem;
    text-align: center;
    color: #9f9f9f;
    padding: 10px 0 20px 0;

    a {
      color: #8d8d8d;
    }
  }
</style>



// WEBPACK FOOTER //
// src/AppSeestadtBot.vue